import { PDFClasses } from '../../api/objects.js';
import PDFAcroTerminal from './PDFAcroTerminal.js';
class PDFAcroSignature extends PDFAcroTerminal {
    myClass() {
        return PDFClasses.PDFAcroSignature;
    }
}
PDFAcroSignature.className = () => PDFClasses.PDFAcroSignature;
PDFAcroSignature.fromDict = (dict, ref) => new PDFAcroSignature(dict, ref);
export default PDFAcroSignature;
//# sourceMappingURL=PDFAcroSignature.js.map